/**
 * Active state for MarketingSiteHeader links (About / History / News / Gallery / Crops / variety sheets).
 */
export default function marketingHeaderNavIsCurrent(link, path) {
  const href = link.href;
  const isAbout = href === '/about' || href === '#about';
  const isHistory = href === '/history';
  const isNews = href === '/news';
  const isGallery = href === '/gallery';
  const isCropCategoryHref = typeof href === 'string' && href.startsWith('/crops/');
  const isSeedVarieties = href === '/seed-varieties';
  return (
    (isAbout && path === '/about') ||
    (isHistory && path === '/history') ||
    (isNews && path.startsWith('/news')) ||
    (isGallery && (path === '/gallery' || path.startsWith('/gallery/'))) ||
    (isCropCategoryHref && path === href) ||
    (isSeedVarieties &&
      (path === '/seed-varieties' || path.startsWith('/seed-varieties/') || path.startsWith('/crops/')))
  );
}
